const Vue = require("vue")

import CIP from "./CIP.vue"

Array.from(document.querySelectorAll(".js-cip-section")).forEach(item => {
  new Vue({
    el: item,

    components: {
      CIP,
    },

    data() {
      return {
        isLoaded: true,
      }
    },        
  });
});
